import { useEffect, useState, useCallback } from 'react';
import {
  getPreloadsFromPath,
  cacheFactory,
  QuickLoad,
} from '@trello/quickload';
import { syncQuickloadResultsToCache } from './syncQuickloadResultsToCache';

export const useQuickload = () => {
  const [isQuickLoading, setIsQuickLoading] = useState(true);

  /**
   * Syncs quickload data to the apollo cache. This is currently redundant
   * to what we do in loadApiDataFromQuickload, because we call syncDeltaToCache
   * when a request completes. But I imagine that one day we'll get rid of that in
   * favor of code being in src/components
   */
  const syncQuickLoadData = useCallback(async () => {
    await syncQuickloadResultsToCache();

    setIsQuickLoading(false);
  }, [setIsQuickLoading]);

  /**
   * Quickload contains a cache that should be cleared once our caches are hydrated.
   * Here we add promise listeners for when data has been synced to ModelCache and Apollo.
   * When all of them are complete, we can clear quickload.
   */
  const clearQuickloadCache = useCallback(async () => {
    const { preloads } = getPreloadsFromPath();
    const queries = preloads.map(({ queryName }) => queryName);
    await Promise.all([
      ...queries.map((queryName) =>
        cacheFactory.waitForQueryHydratedTo(queryName, 'Apollo'),
      ),
      ...queries.map((queryName) =>
        cacheFactory.waitForQueryHydratedTo(queryName, 'ModelCache'),
      ),
    ]);
    QuickLoad.clear();
  }, []);

  useEffect(() => {
    syncQuickLoadData();
    clearQuickloadCache();
  }, [syncQuickLoadData, clearQuickloadCache]);

  return isQuickLoading;
};
